import { useQuery } from "@tanstack/react-query";

/**
 * Task #205 — Sponsor Hub access probe.
 *
 * Calls /api/sponsor-hub/access so the nav entry and route gate render
 * exactly the same answer the server would give. Falls back to "disabled"
 * on errors so the feature stays invisible when the flag is off.
 */
export interface SponsorHubAccessResponse {
  enabled: boolean;
}

export function useSponsorHubAccess() {
  return useQuery<SponsorHubAccessResponse>({
    queryKey: ["/api/sponsor-hub/access"],
    staleTime: 60_000,
    refetchOnWindowFocus: false,
  });
}
